import '@mdi/font/css/materialdesignicons.css' // Ensure you are using css-loader
import Vue from 'vue';
import Vuetify from 'vuetify/lib';
import no from 'vuetify/src/locale/no';
// import 'vuetify/dist/vuetify.min.css';
import '@/styles/main.scss';

Vue.use(Vuetify);

const ignoreWarnMessage = 'The .native modifier for v-on is only valid on components but it was used on <div>.';
Vue.config.warnHandler = function (msg: any, vm: any, trace: any) {
  // `trace` is the component hierarchy trace
  if (msg === ignoreWarnMessage) {
    msg = vm = trace = null;
  }
}

export default new Vuetify({
  icons: {
    values: {
      trampoline: {component: require('@/assets/icons/trampoline.svg')},
      klatring: {component: require('@/assets/icons/klatring.svg')},
      duosprett: {component: require('@/assets/icons/duosprett.svg')},
      bowling: {component: require('@/assets/icons/bowling.svg')},
      bursdag: {component: require('@/assets/icons/bursdag.svg')},
    },
  },
  theme: {
      options: {
        customProperties: true,
      },
      dark: false,
      themes: {
        light: {
          primary: '#00ace4',
          secondary: '#001938',
          accent: '#001938',
          error: '#bd0057',
          info: '#fccd00',
          success: '#0cba00',
          warning: '#fa540e'
        },
        dark: {
          primary: '#00ace4',
          secondary: '#001938',
          accent: '#001938',
          error: '#bd0057',
          info: '#fccd00',
          success: '#0cba00',
          warning: '#fa540e'
        },
      },
  },
    lang: {
      locales: { no },
      current: 'no',
    },
});
